// import Theme from '../Theme';
import { styled } from 'assets/theme';
import React from 'react';
import Studies from '../Studies';
import { ChartSymbol, ChartTypes, Crosshairs, DateSelector, DrawingToolbar, Periodicity } from './';
// import { ShareChartModal } from './modals';

interface IChartUIWrapperProps {
  id: number,
  ciq: any,
  symbol: string,
  setSymbolAndSave: (newSymbol: any) => void,
  periodicity: { timeUnit: string, interval: number },
  enableDateFilter: boolean,
  setEnableDateFilter: (enabled: boolean) => void,
  setPeriodicityWithLoader: any
  setChartTypeAndSave: any
  chartType: any
  toggleCrosshairsAndSave: any
  showCrosshairs: any
  toggleDrawingToolbar: any
  saveLayout: any
  minDate: Date | undefined
  showDrawingToolbar: boolean
}

export const ChartUIWrapper: React.FunctionComponent<IChartUIWrapperProps> = props => (
  <ciq-UI-Wrapper>
    <CiqNav>
      <SymbolWrapper>
        <ChartSymbol
          ciq={props.ciq}
          symbol={props.symbol}
          setSymbolAndSave={props.setSymbolAndSave}
        />
      </SymbolWrapper>
      <DatePickerWrapper>
        <DateSelector
          ciq={props.ciq}
          enableDateFilter={props.enableDateFilter}
          setEnableDateFilter={props.setEnableDateFilter}
          minDate={props.minDate}
        />
      </DatePickerWrapper>
      <ConfigurationWrapper>
        <Crosshairs
            ciq={props.ciq}
            toggleCrosshairsAndSave={props.toggleCrosshairsAndSave}
            showCrosshairs={props.showCrosshairs}
          />
        <DrawingToolbar showDrawingToolbar={props.showDrawingToolbar} ciq={props.ciq} toggleDrawingToolbar={props.toggleDrawingToolbar} />
        <Periodicity ciq={props.ciq} setPeriodicityWithLoader={props.setPeriodicityWithLoader} />
        <ChartTypes ciq={props.ciq} chartType={props.chartType} setChartTypeAndSave={props.setChartTypeAndSave} />
        <Studies id={props.id} ciq={props.ciq} saveLayout={props.saveLayout} />
      </ConfigurationWrapper>
    </CiqNav>
  </ciq-UI-Wrapper>
);

const CiqNav = styled.nav`
  border: none;
  display: flex;
  flex-wrap: wrap;
`

const SymbolWrapper = styled.div``;
const DatePickerWrapper = styled.div`
  flex-grow:1;
  display: grid;
`;

const ConfigurationWrapper = styled.div`
  display: grid;
  grid-gap: 1em;
  grid-auto-flow: column;
  align-items: center;
  @media screen and (max-width: 1080px) {
    grid-column: span 2
  }
  @media screen and (max-width: 720px) {
    grid-column: span 1
	}
`;
